module.exports = __webpack_public_path__ + "img/new_22_3.ba06e01d.jpg";